<template>
  <div class='rulerX' id="ruleX">
    <div class='inch' v-for="inch in rulerInches">
      <!--<div class='mm' v-for="mm in 10"></div>-->
      <div class='val'><label>{{inch}}</label></div>
    </div>
    <!--<div class='inch'>
      <span>{{inch}}</span>
    </div>-->
  </div>
</template>
<script>
  export default {
    name: 'RulerX',
    data () {
      return {
        rulerInches: []
      }
    },
    created () {
      console.log('RulerX created')
    },
    mounted () {
      console.log('RulerX mounted')
      var ruleX = document.getElementById('ruleX')
      console.log(ruleX)
      console.log(ruleX.offsetWidth)
      let inches = Math.ceil(ruleX.offsetWidth / 96)
      this.rulerInches = []
      for (let i = 0; i < inches; i++) {
        this.rulerInches.push(i)
      }
    },
    updated () {
      console.log('RulerX updated')
    },
    computed: {
    },
    methods: {
      getColumnCss (elm) {
        return {
          position: 'absolute',
          backgroundColor: elm.background_color,
          top: elm.top + 'in',
          left: elm.left + 'in',
          width: elm.width + 'in',
          height: elm.height + 'in',
          fontWeight: elm.bold ? 'bold' : '',
          fontSize: '14px'
          // fontSize: elm.fontsize ? elm.fontsize + 'px' : '20px'
        }
      }
    }
  }
</script>
<style>
  .rulerX {
    position: relative;
    width: 100%;
    margin: 20px auto;
    margin: 0px 0px 20px 0px;
    padding-bottom: 20px;
    height: 14px;
    background-color: rgb(230,230,150);
    color: rgb(230,230,150);
    /*background-color: rgb(0,0,0);*/
    color: #555;
  }

    .rulerX .val {
      /*position: absolute;*/
      float: left;
      border-left: 1px solid #555;
      height: 14px;
      width: calc(1in - 1px);
    }
      .rulerX .val > label {
        /*position: absolute;*/
        /*float: left;
      border-left: 1px solid #555;
      */
        height: 14px;
        width: 1in;
        background-color: red;
        text-align: left;
        padding-top: 14px;
        padding-left: -2px;
      }
    .rulerX .inch {
      /*position: absolute;*/
      float: left;
      border-left: 1px solid #555;
      height: 1in;
      width: 1in;
    }
    .rulerX .mm {
      /*position: absolute;*/
      float: left;
      border-left: 1px solid #555;
      height: 14px;
      width: 1in;
    }
    .ruler .cm,
    .ruler .mm {
      position: absolute;
      border-left: 1px solid #555;
      height: 14px;
      width: 10%;
      width: 1in;
    }

      .ruler .cm:after {
        position: absolute;
        bottom: -15px;
        font: 11px/1 sans-serif;
      }

    .ruler .mm {
      height: 5px;
    }

      .ruler .mm:nth-of-type(5) {
        height: 10px;
      }

    .ruler .cm:nth-of-type(1) {
      left: 0%;
    }

      .ruler .cm:nth-of-type(1):after {
        content: "0";
      }

    .ruler .cm:nth-of-type(2) {
      left: 10%;
    }

      .ruler .cm:nth-of-type(2):after {
        content: "1";
      }

    .ruler .cm:nth-of-type(3) {
      left: 20%;
    }

      .ruler .cm:nth-of-type(3):after {
        content: "2";
      }

    .ruler .cm:nth-of-type(4) {
      left: 30%;
    }

      .ruler .cm:nth-of-type(4):after {
        content: "3";
      }

    .ruler .cm:nth-of-type(5) {
      left: 40%;
    }

      .ruler .cm:nth-of-type(5):after {
        content: "4";
      }

    .ruler .cm:nth-of-type(6) {
      left: 50%;
    }

      .ruler .cm:nth-of-type(6):after {
        content: "5";
      }

    .ruler .cm:nth-of-type(7) {
      left: 60%;
    }

      .ruler .cm:nth-of-type(7):after {
        content: "6";
      }

    .ruler .cm:nth-of-type(8) {
      left: 70%;
    }

      .ruler .cm:nth-of-type(8):after {
        content: "7";
      }

    .ruler .cm:nth-of-type(9) {
      left: 80%;
    }

      .ruler .cm:nth-of-type(9):after {
        content: "8";
      }

    .ruler .cm:nth-of-type(10) {
      left: 90%;
    }

      .ruler .cm:nth-of-type(10):after {
        content: "9";
      }

    .ruler .cm:nth-of-type(11) {
      left: 100%;
    }

      .ruler .cm:nth-of-type(11):after {
        content: "10";
      }

    .ruler .mm:nth-of-type(1) {
      left: 10%;
    }

    .ruler .mm:nth-of-type(2) {
      left: 20%;
    }

    .ruler .mm:nth-of-type(3) {
      left: 30%;
    }

    .ruler .mm:nth-of-type(4) {
      left: 40%;
    }

    .ruler .mm:nth-of-type(5) {
      left: 50%;
    }

    .ruler .mm:nth-of-type(6) {
      left: 60%;
    }

    .ruler .mm:nth-of-type(7) {
      left: 70%;
    }

    .ruler .mm:nth-of-type(8) {
      left: 80%;
    }

    .ruler .mm:nth-of-type(9) {
      left: 90%;
    }

    .ruler .mm:nth-of-type(10) {
      left: 100%;
    }
</style>



// WEBPACK FOOTER //
// RulerX.vue?08144e36